"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const xlsx_1 = require("xlsx");
function parseXlsx(data) {
    const workbook = xlsx_1.read(data, { type: "array" });
    return Object.values(parseWorkbook(workbook))[0];
}
exports.default = parseXlsx;
function parseWorkbook(workbook) {
    return workbook.SheetNames.reduce((obj, sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        obj[sheetName] = parseWorksheet(worksheet);
        return obj;
    }, {});
}
function parseWorksheet(worksheet) {
    const jsonWorksheet = xlsx_1.utils.sheet_to_json(worksheet, {
        raw: false,
    });
    const keys = Object.keys(jsonWorksheet[0]);
    return jsonWorksheet.reduce((ary, row, i) => {
        if (i === 0)
            ary.push(keys);
        ary.push(keys.map((k) => row[k]));
        return ary;
    }, []);
}
